console.log('home-landing-container script engaged');

// variables
const homeLanding = document.querySelector('.home-landing-container');
const mainNav = document.querySelector('#main-nav');
const topBanner2 = document.querySelector('.top-banner');
const bannerClose2 = document.querySelector('.banner-close');

// check is homeLanding exists
if (homeLanding != null) {
	// jQuery start
	(function ($) {
		$(document).ready(function () {
			// variables
			let mainNavHeight = mainNav.offsetHeight;
			let calcFunc = `calc(100vh - ${mainNavHeight}px)`;

			function adjustHomeLanding() {
				mainNavHeight = mainNav.offsetHeight;
				calcFunc = `calc(100vh - ${mainNavHeight}px)`;
				homeLanding.style.setProperty('height', calcFunc);
			}

			setTimeout(() => {
				adjustHomeLanding();
			}, 500); // wait half a second

			$(window).resize(function () {
				setTimeout(() => {
					adjustHomeLanding();
				}, 500); // wait half a second
			});

			if (bannerClose2) {
				bannerClose2.addEventListener('click', function () {
					topBanner2.classList.add('d-none');
					setTimeout(() => {
						adjustHomeLanding();
					}, 100); // wait half a second
				});
			}
		});
	})(jQuery);
	// jQuery end
}
